import React from "react";
import TableOfContents from "../../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./EC20Results.css";
// import the separated file related to the component
import TextEC20Results from "./TextEC20Results.jsx";

const EC20Results = () => {
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "EC20",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "EC20_e",
    },
    {
      level: 2,
      text: "Expression",
      id: "Expression_EC20_e",
    },
    {
      level: 3,
      text: "Western Blot Analysis",
      id: "Western1_e",
    },
    {
      level: 3,
      text: "Coomassie Blue Staining Analysis",
      id: "Coomassie1_e",
    },
    {
      level: 3,
      text: "Western Blot with DTT and Urea Treatment",
      id: "Urea_DTT_e",
    },
    {
      level: 3,
      text: "Immunofluorescence Analysis",
      id: "Immunofluorescence_EC20_e",
    },

    {
      level: 3,
      text: "Zinc Binding Experiment",
      id: "Zinc_Binding_EC20_e",
    },
    {
      level: 3,
      text: "Cadmium Binding Experiment",
      id: "Cadmium_Binding_EC20_e",
    },
    {
      level: 2,
      text: "What did go wrong:",
      id: "What_did_go_wrong_e",
    },
    {
      level: 2,
      text: "Surface Expression EC20",
      id: "Surface_Expression_EC20_e",
    },
    {
      level: 3,
      text: "Proteinase K Assay",
      id: "PK_Experiment_EC20_e",
    },
    {
      level: 3,
      text: "Proteinase K - Enzymatic activity assay",
      id: "Enzymatic_Assay_PK_EC20_e",
    },
    {
      level: 2,
      text: "Sonication",
      id: "Sonication_EC20_e",
    },

  ];

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div>
        {/* divide the section in columns */}
        <div className="grid grid-cols-12 gap-4" style={{ marginLeft: "50px" }}>
          {/* section on the left (=Table of content) */}
          <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
            <div className="sticky top-4 scrollable">
              {/* call the Table of contents with headingData modified above */}
              <TableOfContents headings={headingsData} />
            </div>
          </div>
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
            <TextEC20Results />
          </main>
          {/* display the table of content when the viewport is too small */}
          <div className="md:hidden col-span-12 order-3">
            <TocMobile headings={headingsData} />
          </div>
        </div>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default EC20Results;
